import axios from 'axios'

// 是否显示重新登录
export let isRelogin = {show: false};

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
// console.log(store,'store')
const service = axios.create({
    // axios中请求配置有baseURL选项，表示请求URL公共部分

   baseURL: 'https://first.angelprotectionservices.com/api',
    // baseURL: 'http://192.168.31.43:8081',



    // baseURL: localStorage.getItem('baseURL'),
    // 超时
    timeout: 100000
})
// 0x44360800Ca20EC6371344A9994526585079523e8
// 989360.15 41.55
// request拦截器
service.interceptors.request.use(config => {

    return config
}, error => {
    console.log(error)
    Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
        // 未设置状态码则默认成功状态
        const code = res.data.code || 200;

        return res.data
    },
    error => {
        console.log('err' + error)
        let {message} = error;
        if (message == "Network Error") {
            message = "后端接口连接异常";
        } else if (message.includes("timeout")) {
            message = "系统接口请求超时";
        } else if (message.includes("Request failed with status code")) {
            message = "系统接口" + message.substr(message.length - 3) + "异常";
        }

        return Promise.reject(error)
    }
)


let test = (a, b, v) => {
    let obj;
    return new Promise(resolve => {
        if (a.method == 'get') {
            obj = {
                code: 200,
                rows: [],
                msg: '异常'
            }
        } else {
            obj = {
                code: 200,
                msg: '异常'
            }
        }
        resolve(obj)
    })
}


// export default test
export default service
